/**
 * Created by idea on 03/07/2017.
 */
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { AdminHeaderComponent } from './admin-header.component';
import { HelperModule } from '../../common/helper/helper.module';
import { FormsModule } from '@angular/forms';
import { MytabModule } from '../mytab/mytab.module';
import { TabsComponent } from '../tabs/tabs.component';
import { UserProfileComponent } from './user-status/user-status.component';
import { ComponentsModule } from '../../components/component.module';

@NgModule({
  declarations: [AdminHeaderComponent, UserProfileComponent],
  imports: [BrowserModule, RouterModule, HelperModule, FormsModule, MytabModule, ComponentsModule],
  exports: [AdminHeaderComponent, UserProfileComponent],
})
export class HeaderModule {}



// WEBPACK FOOTER //
// ./src/app/layout/header/header.module.ts